import {
  DollarOutlined,
  InboxOutlined,
  NotificationOutlined,
  ProductOutlined,
  ShoppingOutlined,
  ToolOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Col, Flex, Input, Modal, Radio, Row, Upload } from "antd";
import { useState } from "react";
import { IUploadDocument } from "../../models/Document";
import { useUploadDocument } from "../../query/DocumentQuery";
import { notify } from "../../utils/toast";
import FormIcon from "../icons/FormIcon";
import WarehouseIcon from "../icons/WarehouseIcon";

const { Dragger } = Upload;

interface IModalUploadDocumentProps {
  open: boolean;
  onClose: () => void;
}

const ModalUploadDocument = ({ open, onClose }: IModalUploadDocumentProps) => {
  const [documentName, setDocumentName] = useState<string>("");
  const [fileCategory, setFileCategory] = useState<string>("");
  const [file, setFile] = useState<any>(null);
  const uploadMutation = useUploadDocument();
  const handleUpload = async () => {
    if (!documentName.trim()) {
      notify.error("Vui lòng nhập tên tài liệu");
      return;
    }
    if (!fileCategory) {
      notify.error("Vui lòng chọn danh mục");
      return;
    }
    if (!file) {
      notify.error("Vui lòng chọn file");
      return;
    }
    try {
      const formValue: IUploadDocument = {
        documentName,
        file,
        fileCategory,
      };
      await uploadMutation.mutateAsync(formValue);
      notify.success("Đã upload file thành công", `Tên file: ${documentName}`);
      handleClose();
    } catch (error) {
      notify.error("Upload không thành công");
    }
  };
  const handleClose = () => {
    onClose();
    setDocumentName("");
    setFileCategory("");
    setFile(null);
  };

  const categoryOptions = [
    {
      label: "Hành chính",
      value: "Hành chính",
      icon: <UserOutlined />,
    },
    {
      label: "Nhân sự",
      value: "Nhân sự",
      icon: <UserOutlined />,
    },
    {
      label: "Kế toán",
      value: "Kế toán",
      icon: <DollarOutlined />,
    },
    {
      label: "Marketing",
      value: "Marketing",
      icon: <NotificationOutlined />,
    },
    {
      label: "Kỹ thuật",
      value: "Kỹ thuật",
      icon: <ToolOutlined />,
    },
    {
      label: "Sản xuất",
      value: "Sản xuất",
      icon: <ProductOutlined />,
    },
    {
      label: "Kho",
      value: "Kho",
      icon: <WarehouseIcon />,
    },
    {
      label: "Bán hàng",
      value: "Bán hàng",
      icon: <ShoppingOutlined />,
    },
    {
      label: "Khác",
      value: "Khác",
      icon: <FormIcon />,
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      title="Upload tài liệu"
      footer={[
        <Button key="cancel" onClick={handleClose}>
          Hủy
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleUpload}
          loading={uploadMutation.isPending}
        >
          Upload
        </Button>,
      ]}
      width={600}
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2">
            Tên tài liệu <span className="text-red-500">*</span>
          </label>
          <Input
            value={documentName}
            onChange={(e) => setDocumentName(e.target.value)}
            placeholder="Nhập tên tài liệu"
            size="large"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">
            Danh mục <span className="text-red-500">*</span>
          </label>
          <Radio.Group
            value={fileCategory}
            onChange={(e) => setFileCategory(e.target.value)}
            style={{ width: "100%" }}
          >
            <Row gutter={[0, 16]}>
              {categoryOptions.map((item) => (
                <Col span={8} key={item.value}>
                  <Radio value={item.value}>
                    <Flex align="center" gap={8} component="span">
                      <span>{item.icon}</span>
                      <span>{item.label}</span>
                    </Flex>
                  </Radio>
                </Col>
              ))}
            </Row>
          </Radio.Group>
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">
            Chọn file <span className="text-red-500">*</span>
          </label>
          <Dragger
            maxCount={1}
            name="file"
            beforeUpload={(uploadedFile) => {
              setFile(uploadedFile);
              return false;
            }}
            onRemove={() => setFile(null)}
            fileList={file ? [file] : []}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click hoặc kéo file vào đây để upload
            </p>
          </Dragger>
        </div>
      </div>
    </Modal>
  );
};

export default ModalUploadDocument;
